(ns bec-core.cljs.config
  (:require [bec-cljs-common.core :as bcc.core]))

(goog-define VERSION "")

(def is-dev-env? goog.DEBUG)

(defn get-bec-core-server-url []
  (if is-dev-env?
    "../bec-core-server"
    "https://gcs.thesocialgaminggroup.com"))

(bcc.core/init!
  "bec-core"
  "bec-core-client"
  (get-bec-core-server-url)
  [:bec-core-server]
  "bec-core-client")
